import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Toggle from "components/form/toggle/Toggle";
import { IWebsiteBuilderElementStretch } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderElement";
import { cloneDeep } from "lodash";
import { useAppDispatch } from "hooks/redux";
import { websiteBuilderUpdateElementStretch } from "redux/actions/websiteBuilder/websiteBuilder";
import { WebsiteBuilderRange } from "pages/secure/facility/websiteBuilder/editor/components/range/WebsiteBuilderRange";
import { WebsiteBuilderPopupSections } from "../../../helpers/popup/WebsiteBuilderPopupSections";
import {
  useWebsiteBuilderDebouncedUpdate,
  WebsiteBuilderDebouncedUpdateTime,
} from "pages/secure/facility/websiteBuilder/editor/hooks/debouncedUpdate/useWebsiteBuilderDebouncedUpdate";

interface IStretchSettingsProps {
  id: string;
  stretch: IWebsiteBuilderElementStretch;
}

export function StretchSettings(props: IStretchSettingsProps) {
  const { id, stretch } = props;
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const [updatedStretch, setUpdatedStretch] = useState<IWebsiteBuilderElementStretch>(cloneDeep(stretch));

  function dispatchStretch(prevStretch: IWebsiteBuilderElementStretch, nextStretch: IWebsiteBuilderElementStretch) {
    dispatch(
      websiteBuilderUpdateElementStretch({
        id,
        prevStretch: cloneDeep(prevStretch),
        nextStretch: cloneDeep(nextStretch),
      }),
    );
  }

  const { handleUpdateState, handleDebouncedUpdateState } = useWebsiteBuilderDebouncedUpdate({
    state: stretch,
    updatedState: updatedStretch,
    setUpdatedState: setUpdatedStretch,
    dispatchState: dispatchStretch,
    debouncedUpdateTime: WebsiteBuilderDebouncedUpdateTime.MEDIUM,
  });

  function renderStretchSection() {
    return (
      <Toggle
        labelRight={t("Stretch to full width")}
        checked={updatedStretch.enabled}
        onChange={e =>
          handleUpdateState(prev => ({
            ...prev,
            enabled: e.target.checked,
          }))
        }
      />
    );
  }

  function renderMarginSection() {
    if (updatedStretch.enabled) {
      return (
        <WebsiteBuilderRange
          label={t("Margin (px)")}
          min={0}
          max={100}
          step={1}
          value={updatedStretch.margin}
          setValue={margin =>
            handleDebouncedUpdateState(prev => ({
              ...prev,
              margin,
            }))
          }
        />
      );
    }
  }

  return <WebsiteBuilderPopupSections sections={[renderStretchSection(), renderMarginSection()]} />;
}
